var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"progress",attrs:{"id":"progress"}},[_c('p',{staticClass:"progressbar-text",staticStyle:{"font-size":"1.6rem"}})])])}]

export { render, staticRenderFns }